<template>
  <div>
    <p ref="title">
      <b>{{component.text}}</b>
    </p>

    <v-select
      :disabled="optionsTypes.length === 0"
      v-model="localValues[component.id]"
      :label="component.label"
      :items="optionsTypes || []"
    />

    <p v-if="optionsTypes.length === 0" ref="title">
      Selecione primeiro o tipo de intervenção
    </p>

    <v-select
      v-if="radiologicFindingIsSelected"
      v-model="localValues.radiologicFinding"
      :label="$t('Neuroradiology.radiologicFinding')"
      :items="radiologicFindingTypes || []"
    />

    <div v-if="hypertensionIsSelected">
      <p ref="title">
        <b>{{ $t('Neuroradiology.hsa') }}</b>
      </p>

      <div class="ml-2">
        <p class="ml-2" ref="title">
          <b>{{ $t('Neuroradiology.classification') }}</b>
        </p>
        <div class="ml-4">
          <v-select
            v-model="localValues.hsaHuntHess"
            :items="scaleUntil5"
            :label="$t('Neuroradiology.huntHess')"
          />

          <v-select
            v-model="localValues.hsaGCS"
            :items="scaleFrom3To15"
            :label="$t('Neuroradiology.gcs')"
          />

          <v-select
            v-model="localValues.hsaFisherScaleModified"
            :items="scaleUntil4"
            :label="$t('Neuroradiology.fisherScaleModified')"
          />
        </div>

        <p class="ml-2" ref="title">
          <b>{{ $t('Neuroradiology.angiography') }}</b>
        </p>

        <div class="ml-4">
          <b>{{ $t('Neuroradiology.aneurism') }}</b>
          <v-radio-group v-model="localValues.hsaAneurysm" row>
            <v-radio :label="$t('common.Yes')" value="yes" key="yes" />
            <v-radio
              :label="$t('Neuroradiology.greaterThan1')"
              value=">1"
              key=">1"
            />
            <v-radio :label="$t('common.No')" value="no" key="no" />
          </v-radio-group>

          <v-select
            v-if="isOther"
            v-model="localValues.hsaOtherDiagnosis"
            :items="otherTypes"
            :label="$t('Neuroradiology.anotherDiagnosis')"
          />

          <v-text-field
            v-if="localValues.hsaOtherDiagnosis === 'other'"
            v-model="localValues.hsaOtherDiagnosisText"
            type="text"
            :label="$t('common.other')"
          />

          <div v-if="isNotOther || isGreaterThan1">
            <div
              v-for="(item, index) in localValues.angiographyList"
              :key="index"
            >
              <v-select
                v-model="item.hsaLocal"
                :items="locals"
                :label="$t('common.Local')"
              />

              <v-text-field
                v-if="item.hsaOtherType === 'others'"
                v-model="item.hsaOtherLocal"
                type="text"
                :label="$t('common.other')"
              />

              <v-select
                v-if="!isOther"
                v-model="item.hsaSide"
                :items="sides"
                :label="$t('common.side')"
              />

              <b>{{ $t('common.measures') }}</b>
              <div class="ml-4">
                <v-text-field
                  v-model="item.hsaHeight"
                  type="number"
                  :label="$t('common.height')"
                />
                <v-text-field
                  v-model="item.hsaWitdh"
                  type="number"
                  :label="$t('common.width')"
                />
                <v-text-field
                  v-model="item.hsaAP"
                  type="number"
                  :label="$t('Neuroradiology.ap')"
                />
                <v-text-field
                  v-model="item.hsaLap"
                  type="number"
                  :label="$t('Neuroradiology.lap')"
                />

                <b>{{ $t('Neuroradiology.neckBagRatio') }}</b>
                <v-radio-group v-model="item.hsaNeckBagRatio" row>
                  <v-radio
                    :label="$t('Neuroradiology.greaterThan1')"
                    value=">1"
                    key=">1"
                  />
                  <v-radio
                    :label="$t('Neuroradiology.lessThan1')"
                    value="<1"
                    key="<1"
                  />
                </v-radio-group>
              </div>
            </div>

            <v-btn
              class="mb-4"
              v-if="isGreaterThan1"
              @click="localValues.angiographyList.push({})"
              small
              color="primary"
              dark
            >
              <v-icon>add</v-icon>
              Adicionar Novo Aneurisma
            </v-btn>
          </div>
        </div>

        <p class="ml-2" ref="title">
          <b>{{ $t('Neuroradiology.hydrocephalus') }}</b>
        </p>
        <div class="ml-4">
          <v-radio-group v-model="localValues.hsaHydrocephalus" row>
            <v-radio
              v-for="option in yesNoOptions"
              :label="option.text"
              :value="option.value"
              :key="option.value"
            />
          </v-radio-group>

          <b v-if="localValues.hsaHydrocephalus === 'yes'">
            {{ $t('Neuroradiology.dve') }}
          </b>

          <v-radio-group v-if="localValues.hsaHydrocephalus === 'yes'" row>
            <v-radio
              v-for="option in yesNoOptions"
              :label="option.text"
              :value="option.value"
              :key="option.value"
            />
          </v-radio-group>
        </div>

        <p class="ml-2" ref="title">
          <b>{{ $t('common.therapy') }}</b>
        </p>

        <div class="ml-4">
          <v-checkbox
            class="mt-0 mb-0"
            :label="$tc('common.Surgery', 1)"
            v-model="localValues.hsaSurgery"
          />

          <v-checkbox
            class="mt-0 mb-0"
            :label="$t('Neuroradiology.embolization')"
            v-model="localValues.hsaEmbolization"
          />

          <div class="ml-4" v-if="localValues.hsaEmbolization">
            <v-text-field
              v-model="localValues.hsaCoils"
              type="text"
              :label="$t('Neuroradiology.coils')"
            />
            <v-text-field
              v-model="localValues.hsaStent"
              type="text"
              :label="$t('Neuroradiology.stent')"
            />
            <v-select
              v-model="localValues.hsaRaymondResult"
              :items="scaleUntil3"
              :label="$t('Neuroradiology.raymondResult')"
            />
          </div>
        </div>

        <p class="ml-2" ref="title">
          <b>{{ $t('Neuroradiology.vasospasm') }}</b>
        </p>

        <div class="ml-4">
          <v-radio-group v-model="localValues.hsaVasospasm" row>
            <v-radio
              v-for="option in yesNoOptions"
              :label="option.text"
              :value="option.value"
              :key="option.value"
            />
          </v-radio-group>

          <div v-if="localValues.hsaVasospasm === 'yes'" class="ml-4">
            <div
              :key="index"
              v-for="(item, index) in localValues.hsaVasospasmList"
              class="mb-4"
            >
              <DatePickerPopUp
                :max="new Date().toISOString().substring(0, 10)"
                :label="$t('common.Date')"
                v-model="item.vasospasmDate"
              />

              <br />

              <b>{{ $t('Neuroradiology.degree') }}</b>
              <v-radio-group v-model="item.hsaDegree" row>
                <v-radio
                  :label="$t('Neuroradiology.light')"
                  value="light"
                  key="light"
                />
                <v-radio
                  :label="$t('Neuroradiology.moderate')"
                  value="moderate"
                  key="moderate"
                />
                <v-radio
                  :label="$t('Neuroradiology.severe')"
                  value="severe"
                  key="severe"
                />
              </v-radio-group>

              <v-text-field
                v-model="item.hsaLocal"
                type="text"
                :label="$t('common.Local')"
              />

              <b>{{ $t('Neuroradiology.ischemia') }}</b>
              <v-radio-group v-model="item.hsaIschemia" row>
                <v-radio :label="$t('Neuroradiology.tc')" value="tc" key="tc" />
                <v-radio :label="$t('Neuroradiology.rm')" value="rm" key="rm" />
              </v-radio-group>

              <b>{{ $t('common.therapy') }}</b>
              <v-text-field
                v-model="item.hsaNimodipine"
                type="number"
                :label="$t('common.nimodipine') + '(mg)'"
              />
              <v-text-field
                v-model="item.hsaVerapamil"
                type="number"
                :label="$t('common.verapamil') + '(mg)'"
              />
              <v-text-field
                v-model="item.hsaMilrinona"
                type="number"
                :label="$t('common.milrinona') + '(mg)'"
              />
              <v-text-field
                v-model="item.hsaBalloon"
                type="text"
                :label="$t('common.balloon')"
              />

              <v-text-field
                v-model="item.hsaOtherText"
                type="text"
                :label="$t('common.other')"
              />
            </div>

            <v-btn
              class="mb-4"
              @click="localValues.hsaVasospasmList.push({})"
              small
              color="primary"
              dark
            >
              <v-icon>add</v-icon>
              Adicionar Novo Vasoespasmo
            </v-btn>
          </div>
        </div>

        <p class="ml-2" ref="title">
          <b>{{ $t('common.closing') }}</b>
        </p>

        <div class="ml-4">
          <v-radio-group v-model="localValues.hsaClosure" row>
            <v-radio
              :label="$t('Neuroradiology.angioSeal')"
              value="angioseal"
              key="angioseal"
            />
            <v-radio
              :label="$t('Neuroradiology.manualCompression')"
              value="manual-compression"
              key="manual-compression"
            />
            <v-radio label="ExoSeal" value="exoSeal" key="exoSeal" />
            <v-radio label="Starclose" value="starclose" key="starclose" />
            <v-radio :label="$t('common.other')" value="others" key="others" />
          </v-radio-group>

          <v-text-field
            v-if="localValues.hsaClosure === 'others'"
            v-model="localValues.hsaOtherText"
            type="text"
            :label="$t('common.other')"
          />
        </div>

        <p class="ml-2" ref="title">
          <b>{{ $t('Neuroradiology.destinationService') }}</b>
        </p>

        <div class="ml-4">
          <v-text-field
            type="text"
            v-model="localValues.hsaDestinationService"
            :label="$t('Neuroradiology.destinationService')"
          />
        </div>
      </div>
    </div>

    <div
      v-if="
        intracranialHemorrhageIsSelected ||
          isRadiologicFindingIntracranialStenosisIsSelected
      "
    >
      <p ref="title">
        <b>{{ $t('Neuroradiology.intracranialHemorrhage') }}</b>
      </p>

      <div class="ml-4">
        <v-select
          v-model="localValues.ihGCS"
          :items="scaleFrom3To15"
          :label="$t('Neuroradiology.gcs')"
        />

        <v-select
          v-model="localValues.ihIntracranialHemorrhage"
          :items="ihIntracranialHemorrhageOptions"
          label="Motivo"
        />

        <v-text-field
          v-if="localValues.ihIntracranialHemorrhage === 'other'"
          v-model="localValues.ihOtherText"
          type="text"
          :label="$t('common.other')"
        />

        <div
          v-if="localValues.ihIntracranialHemorrhage === 'aneurysm'"
          class="ml-4"
        >
          <b>{{ $t('Neuroradiology.aneurism') }}</b>
          <v-radio-group v-model="localValues.hsaAneurysm" row>
            <v-radio :label="$t('common.Yes')" value="yes" key="yes" />
            <v-radio
              :label="$t('Neuroradiology.greaterThan1')"
              value=">1"
              key=">1"
            />
          </v-radio-group>

          <v-select
            v-if="isOther"
            v-model="localValues.hsaOtherDiagnosis"
            :items="otherTypes"
            :label="$t('Neuroradiology.anotherDiagnosis')"
          />

          <v-text-field
            v-if="localValues.hsaOtherDiagnosis === 'other'"
            v-model="localValues.hsaOtherDiagnosisText"
            type="text"
            :label="$t('common.other')"
          />

          <div v-if="isNotOther || isGreaterThan1">
            <div
              v-for="(item, index) in localValues.angiographyList"
              :key="index"
            >
              <v-select
                v-model="item.hsaLocal"
                :items="locals"
                :label="$t('common.Local')"
              />

              <v-text-field
                v-if="item.hsaOtherType === 'others'"
                v-model="item.hsaOtherLocal"
                type="text"
                :label="$t('common.other')"
              />

              <v-select
                v-if="!isOther"
                v-model="item.hsaSide"
                :items="sides"
                :label="$t('common.side')"
              />

              <b>{{ $t('common.measures') }}</b>
              <div class="ml-4">
                <v-text-field
                  v-model="item.hsaHeight"
                  type="number"
                  :label="$t('common.height')"
                />
                <v-text-field
                  v-model="item.hsaWitdh"
                  type="number"
                  :label="$t('common.width')"
                />
                <v-text-field
                  v-model="item.hsaAP"
                  type="number"
                  :label="$t('Neuroradiology.ap')"
                />
                <v-text-field
                  v-model="item.hsaLap"
                  type="number"
                  :label="$t('Neuroradiology.lap')"
                />

                <b>{{ $t('Neuroradiology.neckBagRatio') }}</b>
                <v-radio-group v-model="item.hsaNeckBagRatio" row>
                  <v-radio
                    :label="$t('Neuroradiology.greaterThan1')"
                    value=">1"
                    key=">1"
                  />
                  <v-radio
                    :label="$t('Neuroradiology.lessThan1')"
                    value="<1"
                    key="<1"
                  />
                </v-radio-group>
              </div>
            </div>

            <v-btn
              class="mb-4"
              v-if="isGreaterThan1"
              @click="localValues.angiographyList.push({})"
              small
              color="primary"
              dark
            >
              <v-icon>add</v-icon>
              Adicionar Novo Aneurisma
            </v-btn>
          </div>
        </div>
      </div>
    </div>

    <div v-if="acuteIschemicStrokeIsSelected">
      <p ref="title">
        <b>{{ $t('Neuroradiology.acuteIschemicStroke') }}</b>
      </p>

      <p class="ml-2" ref="title">
        <b>{{ $t('common.Scale') }}</b>
      </p>

      <div class="ml-4">
        <v-select
          v-model="localValues.aissRankin"
          :items="scaleFrom0To5"
          label="Rankin prévio"
        />

        <v-text-field
          v-model="localValues.aissNISS"
          type="number"
          label="NISS à entrada"
        />

        <TimePicker
          v-model="localValues.aissStartTime"
          :label="$t('Neuroradiology.symptomsStartTime')"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.tac') }}</b>
      </p>

      <div class="ml-4">
        <b>Hiperdensidade espontânea vascular</b>
        <v-radio-group v-model="localValues.aissACMHyperdensity" row>
          <v-radio
            v-for="option in yesNoOptions"
            :label="option.text"
            :value="option.value"
            :key="option.value"
          />
        </v-radio-group>

        <v-text-field
          v-model="localValues.aissAspects"
          type="number"
          :label="$t('Neuroradiology.ASPECTS')"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.evFibrinolyticTherapy') }}</b>
      </p>

      <div class="ml-4">
        <v-radio-group v-model="localValues.aissEvFibrinolyticTherapy" row>
          <v-radio
            v-for="option in yesNoOptions"
            :label="option.text"
            :value="option.value"
            :key="option.value"
          />
        </v-radio-group>

        <v-radio-group
          v-if="localValues.aissEvFibrinolyticTherapy === 'yes'"
          v-model="localValues.aissEvFibrinolyticTherapyValue"
          row
        >
          <v-radio label="0,6mg/kg" value="0,6" key="0,6" />
          <v-radio label="0,9mg/kg" value="0,9" key="0,9" />
        </v-radio-group>
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.times') }}</b>
      </p>

      <div class="ml-4">
        <TimePicker
          v-model="localValues.aissJoinAngiographyRoomTime"
          :label="$t('Neuroradiology.joinAngiographyRoomTime')"
        />

        <TimePicker
          v-model="localValues.aissAngiographyStartTime"
          :label="$t('Neuroradiology.angiographyStartTime')"
        />

        <TimePicker
          v-model="localValues.aissStartTimeThrombolysisThrombectomy"
          :label="$t('Neuroradiology.startTimeThrombolysisThrombectomy')"
        />

        <TimePicker
          v-model="localValues.aissRecanalizationTime"
          :label="$t('Neuroradiology.recanalizationTime')"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.anesthesia') }}</b>
      </p>

      <div class="ml-4">
        <p>
          <b>{{ $t('Neuroradiology.anesthesia') }}</b>
        </p>
        <v-radio-group v-model="localValues.aissAnesthesiaLocal" row>
          <v-radio :label="$t('common.Local')" value="local" key="local" />
          <v-radio :label="$t('common.General')" value="geral" key="geral" />
        </v-radio-group>

        <v-radio-group
          v-if="localValues.aissAnesthesiaLocal === 'geral'"
          v-model="localValues.aissExtubatedOrIntubated"
          row
        >
          <v-radio
            :label="$t('Neuroradiology.extubated')"
            value="extubated"
            key="extubated"
          />
          <v-radio
            :label="$t('Neuroradiology.intubated')"
            value="intubated"
            key="intubated"
          />
        </v-radio-group>

        <p v-if="localValues.aissExtubatedOrIntubated === 'intubated'">
          <b>{{
            $t('Neuroradiology.ventilation') +
              $t('Neuroradiology.spontaneous') +
              '/' +
              $t('Neuroradiology.assisted')
          }}</b>
        </p>
        <v-radio-group
          v-if="localValues.aissExtubatedOrIntubated === 'intubated'"
          v-model="localValues.aissSpontaneousOrAssisted"
          row
        >
          <v-radio
            :label="$t('Neuroradiology.spontaneous')"
            value="spontaneous"
            key="spontaneous"
          />
          <v-radio
            :label="$t('Neuroradiology.assisted')"
            value="assisted"
            key="assisted"
          />
        </v-radio-group>
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.thrombusLocation') }}</b>
      </p>

      <div class="ml-4">
        <v-radio-group v-model="localValues.aissThrombusLocationSide" row>
          <v-radio
            v-for="option in directionOptions"
            :label="option.text"
            :value="option.value"
            :key="option.value"
          />
        </v-radio-group>

        <v-select
          label="Local do Trombo"
          v-model="localValues.aissThrombusLocation"
          :items="thrombusLocationOptions"
        />

        <v-text-field
          v-if="localValues.aissThrombusLocationSide === 'others'"
          v-model="aissThrombusLocationSideOther"
          type="text"
          :label="$t('common.other')"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.endovascularTherapy') }}</b>
      </p>

      <div class="ml-4">
        <v-checkbox
          class="mt-0 mb-0"
          :label="$t('Neuroradiology.thrombolysis')"
          v-model="localValues.aissThrombolysis"
        />

        <div v-if="localValues.aissThrombolysis">
          <v-text-field type="number" label="rTPA(mg)" />
        </div>

        <v-checkbox
          class="mt-0 mb-0"
          :label="$t('Neuroradiology.thrombectomy')"
          v-model="localValues.aissThrombectomy"
        />

        <div v-if="localValues.aissThrombectomy">
          <v-checkbox
            class="mt-0 mb-0"
            :label="$t('Neuroradiology.merci')"
            v-model="localValues.aissMerci"
          />
          <v-text-field
            v-if="localValues.aissMerci"
            v-model="localValues.aissMerciValue"
            type="number"
            :label="$t('Neuroradiology.passages')"
          />

          <v-checkbox
            class="mt-0 mb-0"
            :label="$t('Neuroradiology.penumbra')"
            v-model="localValues.aissPenumbra"
          />
          <v-text-field
            v-if="localValues.aissPenumbra"
            v-model="localValues.aissPenumbraValue"
            type="number"
            :label="$t('Neuroradiology.passages')"
          />

          <v-checkbox
            class="mt-0 mb-0"
            label="TREVO"
            v-model="localValues.aissTrevo"
          />
          <v-text-field
            v-if="localValues.aissTrevo"
            v-model="localValues.aissTrevoValue"
            type="number"
            :label="$t('Neuroradiology.passages')"
          />

          <v-checkbox
            class="mt-0 mb-0"
            :label="$t('common.balloon')"
            v-model="localValues.aissBalloon"
          />
          <v-text-field
            v-if="localValues.aissBalloon"
            v-model="localValues.aissBalloonValue"
            type="number"
            label="mm"
          />

          <v-checkbox
            class="mt-0 mb-0"
            :label="$t('Neuroradiology.solitaire')"
            v-model="localValues.aissSolitaire"
          />
          <v-text-field
            v-if="localValues.aissSolitaire"
            v-model="localValues.aissSolitaireValue"
            type="text"
            :label="$t('Neuroradiology.solitaire')"
          />

          <v-checkbox
            class="mt-0 mb-0"
            :label="$t('Neuroradiology.stent')"
            v-model="localValues.aissStent"
          />
          <v-text-field
            v-if="localValues.aissStent"
            v-model="localValues.aissStentValue"
            type="text"
            :label="$t('Neuroradiology.stent')"
          />

          <v-checkbox
            class="mt-0 mb-0"
            :label="$t('common.other')"
            v-model="localValues.aissThrombectomyOther"
          />
          <v-text-field
            v-if="localValues.aissThrombectomyOther"
            v-model="localValues.aissThrombectomyOtherValue"
            type="number"
            :label="$t('Neuroradiology.passages')"
          />
        </div>

        <v-checkbox
          class="mt-0 mb-0"
          :label="$t('Neuroradiology.otherDrugs')"
          v-model="localValues.aissOtherDrugs"
        />

        <div v-if="localValues.aissOtherDrugs">
          <v-checkbox
            class="mt-0 mb-0"
            :label="$t('Neuroradiology.abciximab')"
            v-model="localValues.aissAbciximab"
          />
          <v-text-field
            v-if="localValues.aissAbciximab"
            v-model="localValues.aissAbciximabValue"
            type="number"
            label="mg"
          />

          <v-checkbox
            class="mt-0 mb-0"
            label="AAS"
            v-model="localValues.aissAAS"
          />
          <v-text-field
            v-if="localValues.aissAAS"
            v-model="localValues.aissASSValue"
            type="number"
            label="mg"
          />

          <v-checkbox
            class="mt-0 mb-0"
            :label="$t('common.nimodipine')"
            v-model="localValues.aissNimodipine"
          />
          <v-text-field
            v-if="localValues.aissNimodipine"
            v-model="localValues.aissNimodipineValue"
            type="number"
            label="mg"
          />

          <v-checkbox
            class="mt-0 mb-0"
            :label="$t('common.clopidogrel')"
            v-model="localValues.aissClopidogrel"
          />
          <v-text-field
            v-if="localValues.aissClopidogrel"
            v-model="localValues.aissClopidogrelValue"
            type="number"
            label="mg"
          />

          <v-checkbox
            class="mt-0 mb-0"
            label="Tirofiban"
            v-model="localValues.aissTirofiban"
          />
          <v-text-field
            v-if="localValues.aissTirofiban"
            v-model="localValues.aissTirofibanValue"
            type="number"
            label="mg"
          />

          <v-checkbox
            class="mt-0 mb-0"
            label="Eptifibatide"
            v-model="localValues.aissEptifibatide"
          />
          <v-text-field
            v-if="localValues.aissEptifibatide"
            v-model="localValues.aissEptifibatideValue"
            type="number"
            label="mg"
          />

          <v-checkbox
            class="mt-0 mb-0"
            label="Ticagrelor"
            v-model="localValues.aissTicagrelor"
          />
          <v-text-field
            v-if="localValues.aissTicagrelor"
            v-model="localValues.aissTicagrelorValue"
            type="number"
            label="mg"
          />

          <v-checkbox
            class="mt-0 mb-0"
            :label="$t('common.other')"
            v-model="localValues.aissOtherDrugsOther"
          />
          <v-text-field
            v-if="localValues.aissOtherDrugsOther"
            v-model="localValues.aissOtherDrugsOtherValue"
            type="number"
            label="mg"
          />
        </div>
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('LogBook.Complications') }}</b>
      </p>

      <div class="ml-4">
        <v-radio-group v-model="localValues.aissComplications" row>
          <v-radio
            v-for="option in yesNoOptions"
            :label="option.text"
            :value="option.value"
            :key="option.value"
          />
        </v-radio-group>

        <v-text-field
          v-if="localValues.aissComplications === 'yes'"
          v-model="localValues.aissComplicationsText"
          type="text"
          :label="$t('LogBook.Complications')"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.recanalization') }}</b>
      </p>

      <div class="ml-4">
        <v-select
          v-model="localValues.aissProximalTici"
          :items="proximalTICIOptions"
          label="TICI"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.closingSystem') }}</b>
      </p>

      <div class="ml-4">
        <v-radio-group v-model="localValues.aissClosingSystem" row>
          <v-radio
            :label="$t('Neuroradiology.angioSeal')"
            value="angioSeal"
            key="angioSeal"
          />
          <v-radio
            :label="$t('Neuroradiology.manualCompression')"
            value="manualCompression"
            key="manualCompression"
          />
          <v-radio label="ExoSeal" value="exoSeal" key="exoSeal" />
          <v-radio label="Starclose" value="starclose" key="starclose" />
          <v-radio :label="$t('common.other')" value="other" key="other" />
        </v-radio-group>

        <v-text-field
          v-if="localValues.aissClosingSystem === 'other'"
          v-model="localValues.aiisClosingSystemOther"
          type="text"
          :label="$t('common.other')"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.destinationService') }}</b>
      </p>

      <div class="ml-4">
        <v-text-field
          type="text"
          v-model="localValues.aissDestinationService"
          :label="$t('Neuroradiology.destinationService')"
        />
      </div>
    </div>

    <div
      v-if="
        symptomaticCarotidStenosisIsSelected ||
          isRadiologicFindingSymptomaticCarotidStenosisIsSelected
      "
    >
      <p ref="title">
        <b>{{ $t('Neuroradiology.symptomaticCarotidStenosis') }}</b>
      </p>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.mcdt') }}</b>
      </p>

      <div class="ml-4">
        <v-text-field type="text" :label="$t('Neuroradiology.dvp')" />
        <v-text-field type="text" :label="$t('Neuroradiology.angioTc')" />
        <v-text-field type="text" :label="$t('Neuroradiology.rm')" />
        <v-text-field type="text" :label="$t('Neuroradiology.perfusion')" />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.lastStroke') }}</b>
      </p>

      <div class="ml-4">
        <DatePickerPopUp
          :max="new Date().toISOString().substring(0, 10)"
          :label="$t('common.Date')"
          v-model="localValues.scsLastStrokeDate"
        />

        <v-select
          v-model="localValues.scsRankin"
          :items="scaleFrom0To5"
          label="Rankin prévio"
        />

        <v-radio-group v-model="localValues.scsStrokeType" row>
          <v-radio
            :label="$t('Neuroradiology.ischemic')"
            value="ischemic"
            key="ischemic"
          />
          <v-radio
            :label="$t('Neuroradiology.hemorrhagic')"
            value="hemorrhagic"
            key="hemorrhagic"
          />
        </v-radio-group>

        <b>{{ $t('Neuroradiology.territory') }}</b>
        <v-radio-group v-model="localValues.scsStrokeLocal" row>
          <v-radio
            :label="$t('Neuroradiology.cortical')"
            value="cortical"
            key="cortical"
          />
          <v-radio
            :label="$t('Neuroradiology.subcortical')"
            value="subCortical"
            key="subCortical"
          />
          <v-radio
            :label="$t('Neuroradiology.corticoSubcortical')"
            value="corticoSubcortical"
            key="corticoSubcortical"
          />
          <v-radio
            :label="$t('Neuroradiology.junctional')"
            value="juncional"
            key="juncional"
          />
        </v-radio-group>
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.previousAntiAggregation') }}</b>
      </p>

      <div class="ml-4">
        <v-text-field
          v-model="localValues.scsAASDays"
          type="number"
          label="AAS (dias)"
        />
        <v-text-field
          v-model="localValues.scsClopidogrel"
          type="number"
          :label="$t('common.clopidogrel') + ' (dias)'"
        />
        <v-text-field
          v-model="localValues.scsTicagrelor"
          type="number"
          :label="$t('common.ticagrelor') + ' (dias)'"
        />
        <v-text-field
          v-model="localValues.scsOther"
          type="text"
          :label="$t('common.other')"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.angiography') }}</b>
      </p>

      <div class="ml-4">
        <v-text-field
          v-model="localValues.scsStenosis"
          min="0"
          max="100"
          type="number"
          label="Estenose (%)"
        />

        <b>ACI</b>
        <v-radio-group v-model="localValues.scsPriorAntiAggregationSide" row>
          <v-radio
            v-for="option in directionOptions"
            :label="option.text"
            :value="option.value"
            :key="option.value"
          />
        </v-radio-group>

        <b>{{ $t('Neuroradiology.hemodynamicChanges') }}</b>
        <v-checkbox
          class="mt-0 mb-0"
          :label="$t('Neuroradiology.circulatoryDelay')"
          v-model="localValues.scsCirculatoryDelay"
        />

        <v-checkbox
          class="mt-0 mb-0"
          :label="$t('Neuroradiology.collateral')"
          v-model="localValues.scsCollateral"
        />

        <div v-if="localValues.scsCollateral" class="ml-4">
          <v-checkbox
            class="mt-0 mb-0"
            :label="$t('Neuroradiology.leptomeningeas')"
            v-model="localValues.scsLeptomeningeas"
          />

          <v-checkbox
            class="mt-0 mb-0"
            label="CoA"
            v-model="localValues.scsCOA"
          />

          <v-checkbox
            class="mt-0 mb-0"
            label="CoP"
            v-model="localValues.scsCOP"
          />

          <v-checkbox
            class="mt-0 mb-0"
            label="ACE"
            v-model="localValues.scsACE"
          />
        </div>
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.anesthesia') }}</b>
      </p>

      <div class="ml-4">
        <v-radio-group v-model="localValues.scsAnesthesiaType" row>
          <v-radio :label="$t('common.Local')" value="local" key="local" />
          <v-radio
            :label="$t('common.General')"
            value="general"
            key="general"
          />
        </v-radio-group>

        <v-radio-group
          v-if="localValues.scsAnesthesiaType === 'general'"
          v-model="localValues.scsAnesthesiaTypeExtubatedIntubated"
          row
        >
          <v-radio
            :label="$t('Neuroradiology.extubated')"
            value="extubated"
            key="extubated"
          />
          <v-radio
            :label="$t('Neuroradiology.intubated')"
            value="intubated"
            key="intubated"
          />
        </v-radio-group>

        <v-radio-group
          v-if="localValues.scsAnesthesiaTypeExtubatedIntubated === 'intubated'"
          row
        >
          <v-radio
            :label="$t('Neuroradiology.spontaneous')"
            value="spontaneous"
            key="spontaneous"
          />
          <v-radio
            :label="$t('Neuroradiology.assisted')"
            value="assisted"
            key="assisted"
          />
        </v-radio-group>
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('common.therapy') }}</b>
      </p>

      <div class="ml-4">
        <v-checkbox
          class="mt-0 mb-0"
          :label="$t('Neuroradiology.stent')"
          v-model="localValues.scsStent"
        />

        <div v-if="localValues.scsStent" class="ml-4">
          <v-text-field type="text" :label="$t('Neuroradiology.stent')" />
          <v-text-field
            type="number"
            :label="$t('Neuroradiology.stent') + ' (mm)'"
          />
        </div>

        <v-checkbox
          class="mt-0 mb-0"
          :label="$t('common.balloon')"
          v-model="localValues.scsBalloon"
        />

        <div v-if="localValues.scsBalloon" class="ml-4">
          <v-text-field type="text" :label="$t('common.balloon')" />
          <v-text-field type="number" :label="$t('common.balloon') + '(mm)'" />
        </div>
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('LogBook.Complications') }}</b>
      </p>

      <div class="ml-4">
        <v-radio-group v-model="localValues.scsComplications" row>
          <v-radio
            v-for="option in yesNoOptions"
            :label="option.text"
            :value="option.value"
            :key="option.value"
          />
        </v-radio-group>

        <v-text-field
          v-if="localValues.scsComplications === 'yes'"
          v-model="localValues.scsComplicationsText"
          type="text"
          :label="$t('common.which?')"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.residualStenosis') }}</b>
      </p>

      <div class="ml-4">
        <v-text-field
          v-model="localValues.scsResidualStenosis"
          min="0"
          max="100"
          type="number"
          :label="$t('Neuroradiology.residualStenosis') + '(%)'"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.closingSystem') }}</b>
      </p>

      <div class="ml-4">
        <v-radio-group v-model="localValues.scsClosingSystem" row>
          <v-radio
            :label="$t('Neuroradiology.angioSeal')"
            value="angioSeal"
            key="angioSeal"
          />
          <v-radio
            :label="$t('Neuroradiology.manualCompression')"
            value="manualCompression"
            key="manualCompression"
          />
          <v-radio label="ExoSeal" value="exoSeal" key="exoSeal" />
          <v-radio label="Starclose" value="starclose" key="starclose" />
          <v-radio :label="$t('common.other')" value="other" key="other" />
        </v-radio-group>

        <v-text-field
          v-if="localValues.scsClosingSystem === 'other'"
          v-model="localValues.scsClosingSystemOther"
          type="text"
          :label="$t('common.other')"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.destinationService') }}</b>
      </p>

      <div class="ml-4">
        <v-text-field
          type="text"
          v-model="localValues.scsDestinationService"
          :label="$t('Neuroradiology.destinationService')"
        />
      </div>
    </div>

    <div v-if="intracranialStenosisIsSelected">
      <p ref="title">
        <b>{{ $t('Neuroradiology.symptomaticIntracranialStenosis') }}</b>
      </p>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.mcdt') }}</b>
      </p>

      <div class="ml-4">
        <v-radio-group v-model="localValues.isMcdt" row>
          <v-radio :label="$t('Neuroradiology.dvp')" value="dvp" key="dvp" />
          <v-radio
            :label="$t('Neuroradiology.angioTc')"
            value="angiotc"
            key="angiotc"
          />
          <v-radio :label="$t('Neuroradiology.rm')" value="rm" key="rm" />
          <v-radio
            :label="$t('Neuroradiology.perfusion')"
            value="perfusion"
            key="perfusion"
          />
        </v-radio-group>

        <v-text-field
          v-model="localValues.isMcdtValue"
          type="text"
          :label="$t('Neuroradiology.mcdt')"
          v-if="localValues.isMcdt"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.lastStroke') }}</b>
      </p>

      <div class="ml-4">
        <DatePickerPopUp
          :max="new Date().toISOString().substring(0, 10)"
          :label="$t('common.Date')"
          v-model="localValues.isLastStrokeDate"
        />
        <v-select
          v-model="localValues.aissRankin"
          :items="scaleFrom0To5"
          label="Rankin prévio"
        />
        <v-radio-group v-model="localValues.isStrokeType" row>
          <v-radio
            :label="$t('Neuroradiology.ischemic')"
            value="ischemic"
            key="ischemic"
          />
          <v-radio
            :label="$t('Neuroradiology.hemorrhagic')"
            value="hemorrhagic"
            key="hemorrhagic"
          />
        </v-radio-group>

        <b>{{ $t('Neuroradiology.territory') }}</b>
        <v-radio-group v-model="localValues.isStrokeLocal" row>
          <v-radio
            :label="$t('Neuroradiology.cortical')"
            value="cortical"
            key="cortical"
          />
          <v-radio
            :label="$t('Neuroradiology.subcortical')"
            value="subCortical"
            key="subCortical"
          />
          <v-radio
            :label="$t('Neuroradiology.corticoSubcortical')"
            value="corticoSubcortical"
            key="corticoSubcortical"
          />
          <v-radio
            :label="$t('Neuroradiology.junctional')"
            value="juncional"
            key="juncional"
          />
        </v-radio-group>
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.previousAntiAggregation') }}</b>
      </p>

      <div class="ml-4">
        <v-text-field
          v-model="localValues.isAASDays"
          type="number"
          label="AAS (dias)"
        />
        <v-text-field
          v-model="localValues.isClopidogrel"
          type="number"
          :label="$t('common.clopidogrel') + ' (dias)'"
        />
        <v-text-field
          v-model="localValues.isTicagrelor"
          type="number"
          :label="$t('common.ticagrelor') + ' (dias)'"
        />
        <v-text-field
          v-model="localValues.isOther"
          type="text"
          :label="$t('common.other')"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.angiography') }}</b>
      </p>

      <div class="ml-4">
        <v-text-field
          min="0"
          max="100"
          type="number"
          v-model="localValues.isStenosis"
          :label="$t('Neuroradiology.stenosis') + '(%)'"
        />

        <b>{{ $t('common.Local') }}</b>
        <v-radio-group v-model="localValues.isLocal" row>
          <v-radio
            v-for="option in directionOptions"
            :label="option.text"
            :value="option.value"
            :key="option.value"
          />
        </v-radio-group>

        <v-select
          label="Local da estenose"
          v-model="localValues.isThrombusLocation"
          :items="thrombusLocationOptions"
        />

        <v-text-field
          v-if="localValues.isThrombusLocation === 'others'"
          v-model="localValues.isThrombusLocationOther"
          type="text"
          :label="$t('common.other')"
        />

        <b>{{ $t('Neuroradiology.hemodynamicChanges') }}</b>
        <v-checkbox
          class="mt-0 mb-0"
          :label="$t('Neuroradiology.circulatoryDelay')"
          v-model="localValues.isCirculatoryDelay"
        />

        <v-checkbox
          class="mt-0 mb-0"
          :label="$t('Neuroradiology.collateral')"
          v-model="localValues.isCollateral"
        />

        <div v-if="localValues.isCollateral" class="ml-4">
          <v-checkbox
            class="mt-0 mb-0"
            :label="$t('Neuroradiology.leptomeningeas')"
            v-model="localValues.isLeptomeningeas"
          />

          <v-checkbox
            class="mt-0 mb-0"
            label="CoA"
            v-model="localValues.isCOA"
          />

          <v-checkbox
            class="mt-0 mb-0"
            label="CoP"
            v-model="localValues.isCOP"
          />

          <v-checkbox
            class="mt-0 mb-0"
            label="ACE"
            v-model="localValues.isACE"
          />
        </div>
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.anesthesia') }}</b>
      </p>

      <div class="ml-4">
        <v-radio-group v-model="localValues.isAnesthesiaType" row>
          <v-radio :label="$t('common.Local')" value="local" key="local" />
          <v-radio
            :label="$t('common.General')"
            value="general"
            key="general"
          />
        </v-radio-group>

        <v-radio-group
          v-if="localValues.isAnesthesiaType === 'general'"
          v-model="localValues.isAnesthesiaTypeExtubatedIntubated"
          row
        >
          <v-radio
            :label="$t('Neuroradiology.extubated')"
            value="extubated"
            key="extubated"
          />
          <v-radio
            :label="$t('Neuroradiology.intubated')"
            value="intubated"
            key="intubated"
          />
        </v-radio-group>

        <v-radio-group
          v-if="localValues.isAnesthesiaTypeExtubatedIntubated === 'intubated'"
          row
        >
          <v-radio
            :label="$t('Neuroradiology.spontaneous')"
            value="spontaneous"
            key="spontaneous"
          />
          <v-radio
            :label="$t('Neuroradiology.assisted')"
            value="assisted"
            key="assisted"
          />
        </v-radio-group>
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('common.therapy') }}</b>
      </p>

      <div class="ml-4">
        <v-checkbox
          class="mt-0 mb-0"
          :label="$t('Neuroradiology.stent')"
          v-model="localValues.isStent"
        />

        <div v-if="localValues.isStent" class="ml-4">
          <v-text-field
            v-model="localValues.isStentText"
            type="text"
            :label="$t('Neuroradiology.stent')"
          />
          <v-text-field
            v-model="localValues.isStentValue"
            type="number"
            :label="$t('Neuroradiology.stent') + ' (mm)'"
          />
        </div>

        <v-checkbox
          class="mt-0 mb-0"
          :label="$t('common.balloon')"
          v-model="localValues.isBalloon"
        />

        <div v-if="localValues.isBalloon" class="ml-4">
          <v-text-field
            v-model="localValues.isBalloonText"
            type="text"
            :label="$t('common.balloon')"
          />
          <v-text-field
            v-model="localValues.isBalloonValue"
            type="number"
            :label="$t('common.balloon') + '(mm)'"
          />
        </div>
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('LogBook.Complications') }}</b>
      </p>

      <div class="ml-4">
        <v-radio-group v-model="localValues.isComplications" row>
          <v-radio
            v-for="option in yesNoOptions"
            :label="option.text"
            :value="option.value"
            :key="option.value"
          />
        </v-radio-group>

        <v-text-field
          v-if="localValues.isComplications === 'yes'"
          v-model="localValues.isComplicationsText"
          type="text"
          :label="$t('LogBook.Complications')"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.residualStenosis') }}</b>
      </p>

      <div class="ml-4">
        <v-text-field
          min="0"
          max="100"
          type="number"
          v-model="localValues.isResidualStenosis"
          :label="$t('Neuroradiology.residualStenosis') + '(%)'"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.closingSystem') }}</b>
      </p>

      <div class="ml-4">
        <v-radio-group v-model="localValues.isClosingSystem" row>
          <v-radio
            :label="$t('Neuroradiology.angioSeal')"
            value="angioSeal"
            key="angioSeal"
          />
          <v-radio
            :label="$t('Neuroradiology.manualCompression')"
            value="manualCompression"
            key="manualCompression"
          />
          <v-radio label="ExoSeal" value="exoSeal" key="exoSeal" />
          <v-radio label="Starclose" value="starclose" key="starclose" />
          <v-radio :label="$t('common.other')" value="other" key="other" />
        </v-radio-group>

        <v-text-field
          v-if="localValues.isClosingSystem === 'other'"
          v-model="localValues.isClosingSystemOther"
          type="text"
          :label="$t('common.other')"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.destinationService') }}</b>
      </p>

      <div class="ml-4">
        <v-text-field
          type="text"
          v-model="localValues.isDestinationService"
          :label="$t('Neuroradiology.destinationService')"
        />
      </div>
    </div>

    <div
      v-if="
        (radiologicFindingIsSelected && isMav) ||
          localValues.ihIntracranialHemorrhage === 'mav'
      "
    >
      <p v-if="radiologicFindingIsSelected && isMav" ref="title">
        <b>{{ $t('Neuroradiology.radiologicFinding') }}</b>
      </p>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.mav') }}</b>
      </p>

      <div class="ml-4">
        <b>{{ $t('common.Local') }}</b>

        <v-select
          v-model="localValues.rfaMcdt"
          :label="$t('common.Local')"
          :items="rfaLocalOptions"
          :multiple="true"
        />

        <b>{{ $t('common.Type') }}</b>
        <v-select
          :multiple="true"
          v-model="localValues.rfaType"
          :label="$t('common.Type')"
          :items="rfaTypeOptions"
        />

        <b>{{ $t('Neuroradiology.afferents') }}</b>
        <v-radio-group v-model="localValues.rfaAfferents" row>
          <v-radio label="1 Território" value="oneLocal" key="oneLocal" />
          <v-radio
            label="> 1 território"
            value="moreThanOneLocal"
            key="moreThanOneLocal"
          />
          <v-radio label="Durais" value="durals" key="durals" />
        </v-radio-group>

        <b>{{ $t('Neuroradiology.aneurysms') }}</b>
        <v-radio-group v-model="localValues.rfaAneurysm" row>
          <v-radio label="Arteriais" value="arterials" key="arterials" />
          <v-radio label="Intranidus" value="intranidus" key="intranidus" />
          <v-radio
            :label="$t('Neuroradiology.venous')"
            value="venous"
            key="venous"
          />
        </v-radio-group>

        <b>{{ $t('Neuroradiology.venousDrainage') }}</b>
        <v-radio-group v-model="localValues.rfaVenousDrainage" row>
          <v-radio label="Superficial" value="shallow" key="shallow" />
          <v-radio label="Profunda" value="deep" key="deep" />
          <v-radio label="Estenose" value="stenosis" key="stenosis" />
        </v-radio-group>

        <b>{{ $t('Neuroradiology.debit') }}</b>
        <v-radio-group v-model="localValues.rfaDebit" row>
          <v-radio :label="$t('common.high')" value="high" key="high" />
          <v-radio
            :label="$t('common.moderated')"
            value="average"
            key="average"
          />
          <v-radio :label="$t('common.low')" value="low" key="low" />
        </v-radio-group>

        <b>{{ $t('common.dimensions') }}</b>
        <v-radio-group v-model="localValues.rfaDimentions" row>
          <v-radio label="micro MAV" value="microMav" key="microMav" />
          <v-radio label="<3" value="<3" key="<3" />
          <v-radio label="3-6" value="3-6" key="3-6" />
          <v-radio label=">6" value=">6" key=">6" />
        </v-radio-group>

        <v-text-field
          v-model="localValues.rfaSpetzlerMartin"
          type="text"
          label="Spetzler-Martin"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('common.presentation') }}</b>
      </p>

      <div class="ml-4">
        <v-radio-group v-model="localValues.rfaPresentation" row>
          <v-radio :label="$t('Neuroradiology.find')" value="find" key="find" />
          <v-radio
            :label="$t('Neuroradiology.seizureCrisis')"
            value="seizureCrisis"
            key="seizureCrisis"
          />
          <v-radio
            :label="$t('Neuroradiology.focalSigns')"
            value="sinaisFocais"
            key="sinaisFocais"
          />
          <v-radio
            :label="$t('Neuroradiology.bleeding')"
            value="bleeding"
            key="bleeding"
          />
        </v-radio-group>
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.endovascularTherapy') }}</b>
      </p>

      <div class="ml-4">
        <b>nBCA</b>
        <v-text-field
          v-model="localValues.rfaNBCA"
          type="number"
          :label="$t('Neuroradiology.pedicles')"
        />
        <v-text-field
          v-model="localValues.rfaDilution"
          type="number"
          :label="$t('Neuroradiology.dilution')"
        />

        <b>Onyx</b>
        <v-text-field
          v-model="localValues.rfaPedicles"
          type="number"
          :label="$t('Neuroradiology.pedicles')"
        />
        <v-text-field
          v-model="localValues.rfaConcentration"
          type="number"
          :label="$t('Neuroradiology.concentration')"
        />

        <b>{{ $t('common.other') }}</b>
        <v-text-field
          v-model="localValues.rfaOther"
          type="text"
          :label="$t('common.other')"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.result') }}</b>
      </p>

      <div class="ml-4">
        <b>{{ $t('Neuroradiology.exclusion') }}</b>
        <v-text-field
          v-model="localValues.rfaExclusion"
          type="number"
          min="0"
          max="100"
          label="%"
        />

        <b>{{ $t('Neuroradiology.venousOcclusion') }}</b>
        <v-radio-group v-model="localValues.rfaVenousOcclusion" row>
          <v-radio
            v-for="option in yesNoOptions"
            :label="option.text"
            :value="option.value"
            :key="option.value"
          />
        </v-radio-group>

        <b>{{ $t('Neuroradiology.afferentPedicleOcclusion') }}</b>
        <v-radio-group v-model="localValues.rfaAfferentPedicleOcclusion" row>
          <v-radio
            v-for="option in yesNoOptions"
            :label="option.text"
            :value="option.value"
            :key="option.value"
          />
        </v-radio-group>
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('LogBook.Complications') }}</b>
      </p>

      <div class="ml-4">
        <v-radio-group v-model="localValues.rfaComplications" row>
          <v-radio
            v-for="option in yesNoOptions"
            :label="option.text"
            :value="option.value"
            :key="option.value"
          />
        </v-radio-group>

        <v-text-field
          v-if="localValues.rfaComplications === 'yes'"
          v-model="localValues.rfaComplicationsText"
          type="text"
          :label="$t('LogBook.Complications')"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.closingSystem') }}</b>
      </p>

      <div class="ml-4">
        <v-radio-group v-model="localValues.rfaClosingSystem" row>
          <v-radio
            :label="$t('Neuroradiology.angioSeal')"
            value="angioSeal"
            key="angioSeal"
          />
          <v-radio
            :label="$t('Neuroradiology.manualCompression')"
            value="manualCompression"
            key="manualCompression"
          />
          <v-radio label="ExoSeal" value="exoSeal" key="exoSeal" />
          <v-radio label="Starclose" value="starclose" key="starclose" />
          <v-radio :label="$t('common.other')" value="other" key="other" />
        </v-radio-group>

        <v-text-field
          v-if="localValues.rfaClosingSystem === 'other'"
          v-model="localValues.rfaClosingSystemOther"
          type="text"
          :label="$t('common.other')"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.destinationService') }}</b>
      </p>

      <div class="ml-4">
        <v-text-field
          type="text"
          v-model="localValues.rfaDestinationService"
          :label="$t('Neuroradiology.destinationService')"
        />
      </div>
    </div>

    <div
      v-if="
        (radiologicFindingIsSelected && isFav) ||
          localValues.ihIntracranialHemorrhage === 'fav'
      "
    >
      <p v-if="radiologicFindingIsSelected && isFav" ref="title">
        <b>{{ $t('Neuroradiology.fav') }}</b>
      </p>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.characterization') }}</b>
      </p>

      <div class="ml-4">
        <b>{{ $t('common.Local') }}</b>
        <v-select
          v-model="localValues.rffLocal"
          :label="$t('common.Local')"
          :items="rffTypeOptions"
          :multiple="true"
        />

        <v-text-field
          type="text"
          v-model="localValues.rffAfferents"
          :label="$t('Neuroradiology.afferents')"
        />

        <v-select
          v-model="localValues.rffVenousDrainage"
          :label="$t('Neuroradiology.venousDrainage')"
          :items="rffVenousDrainageOptions"
          :multiple="true"
        />

        <v-select
          v-model="localValues.rffBordenClassification"
          label="Classificação de Borden"
          :items="rffBordenClassificationOptions"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('common.presentation') }}</b>
      </p>

      <div class="ml-4">
        <v-radio-group v-model="localValues.rffPresentation" row>
          <v-radio :label="$t('Neuroradiology.find')" value="find" key="find" />
          <v-radio
            :label="$t('Neuroradiology.seizureCrisis')"
            value="seizureCrisis"
            key="seizureCrisis"
          />
          <v-radio
            :label="$t('Neuroradiology.focalSigns')"
            value="focalSigns"
            key="focalSigns"
          />
          <v-radio
            :label="$t('Neuroradiology.bleeding')"
            value="bleeding"
            key="bleeding"
          />
          <v-radio
            :label="$t('Neuroradiology.sindDementia')"
            value="sindDementia"
            key="sindDementia"
          />
        </v-radio-group>
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.anesthesia') }}</b>
      </p>

      <div class="ml-4">
        <p>
          <b>{{ $t('Neuroradiology.anesthesia') }}</b>
        </p>
        <v-radio-group v-model="localValues.rffAnesthesiaType" row>
          <v-radio
            :label="$t('common.Local')"
            value="sedationSite"
            key="sedationSite"
          />
          <v-radio :label="$t('common.General')" value="geral" key="geral" />
        </v-radio-group>

        <v-radio-group
          v-if="localValues.rffAnesthesiaType === 'geral'"
          v-model="localValues.rffExtubatedOrIntubated"
          row
        >
          <v-radio
            :label="$t('Neuroradiology.extubated')"
            value="extubated"
            key="extubated"
          />
          <v-radio
            :label="$t('Neuroradiology.intubated')"
            value="intubated"
            key="intubated"
          />
        </v-radio-group>

        <p v-if="localValues.rffExtubatedOrIntubated === 'intubated'">
          <b>
            {{
              $t('Neuroradiology.ventilation') +
                $t('Neuroradiology.spontaneous') +
                '/' +
                $t('Neuroradiology.assisted')
            }}
          </b>
        </p>
        <v-radio-group
          v-if="localValues.rffExtubatedOrIntubated === 'intubated'"
          v-model="localValues.rffSpontaneousOrAssisted"
          row
        >
          <v-radio
            :label="$t('Neuroradiology.spontaneous')"
            value="spontaneous"
            key="spontaneous"
          />
          <v-radio
            :label="$t('Neuroradiology.assisted')"
            value="assisted"
            key="assisted"
          />
        </v-radio-group>
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.endovascularTherapy') }}</b>
      </p>

      <div class="ml-4">
        <b>nBCA</b>
        <v-text-field
          v-model="localValues.rffNBCA"
          type="number"
          :label="$t('Neuroradiology.pedicles')"
        />
        <v-text-field
          v-model="localValues.rffDilution"
          type="number"
          :label="$t('Neuroradiology.dilution')"
        />

        <b>Onyx</b>
        <v-text-field
          v-model="localValues.rffPedicles"
          type="number"
          :label="$t('Neuroradiology.pedicles')"
        />
        <v-text-field
          v-model="localValues.rffConcentration"
          type="number"
          :label="$t('Neuroradiology.concentration')"
        />

        <b>{{ $t('common.other') }}</b>
        <v-text-field
          v-model="localValues.rffOther"
          type="text"
          :label="$t('common.other')"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.result') }}</b>
      </p>

      <div class="ml-4">
        <b>{{ $t('Neuroradiology.exclusion') }}</b>
        <v-text-field
          v-model="localValues.rffExclusion"
          type="number"
          min="0"
          max="100"
          label="%"
        />

        <b>{{ $t('Neuroradiology.venousOcclusion') }}</b>
        <v-radio-group v-model="localValues.rffVenousOcclusion" row>
          <v-radio
            v-for="option in yesNoOptions"
            :label="option.text"
            :value="option.value"
            :key="option.value"
          />
        </v-radio-group>

        <b>{{ $t('Neuroradiology.afferentPedicleOcclusion') }}</b>
        <v-radio-group v-model="localValues.rffAfferentPedicleOcclusion" row>
          <v-radio
            v-for="option in yesNoOptions"
            :label="option.text"
            :value="option.value"
            :key="option.value"
          />
        </v-radio-group>
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('LogBook.Complications') }}</b>
      </p>

      <div class="ml-4">
        <v-radio-group v-model="localValues.rffComplications" row>
          <v-radio
            v-for="option in yesNoOptions"
            :label="option.text"
            :value="option.value"
            :key="option.value"
          />
        </v-radio-group>

        <v-text-field
          v-if="localValues.rffComplications === 'yes'"
          v-model="localValues.rffComplicationsText"
          type="text"
          :label="$t('LogBook.Complications')"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.closingSystem') }}</b>
      </p>

      <div class="ml-4">
        <v-radio-group v-model="localValues.rffClosingSystem" row>
          <v-radio
            :label="$t('Neuroradiology.angioSeal')"
            value="angioSeal"
            key="angioSeal"
          />
          <v-radio
            :label="$t('Neuroradiology.manualCompression')"
            value="manualCompression"
            key="manualCompression"
          />
          <v-radio label="ExoSeal" value="exoSeal" key="exoSeal" />
          <v-radio label="Starclose" value="starclose" key="starclose" />
          <v-radio :label="$t('common.other')" value="other" key="other" />
        </v-radio-group>

        <v-text-field
          v-if="localValues.rffClosingSystem === 'other'"
          v-model="localValues.rffClosingSystemOther"
          type="text"
          :label="$t('common.other')"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.destinationService') }}</b>
      </p>

      <div class="ml-4">
        <v-text-field
          type="text"
          v-model="localValues.rffDestinationService"
          :label="$t('Neuroradiology.destinationService')"
        />
      </div>
    </div>

    <div v-if="vertebralFractureIsSelected">
      <p ref="title">
        <b>{{ $t('Neuroradiology.vertebralFracture') }}</b>
      </p>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.characterization') }}</b>
      </p>

      <div class="ml-4">
        <b>{{ $t('common.Local') }}</b>
        <v-select
          v-model="localValues.vfLocal"
          :label="$t('common.Local')"
          :items="rootOptions"
        />

        <b>{{ $t('Neuroradiology.degreeOfCollapse') }}</b>
        <v-radio-group v-model="localValues.vfDegreeOfCollapse" row>
          <v-radio label="<25%" value="<25" key="<25" />
          <v-radio label="25-50%" value="25-50" key="25-50" />
          <v-radio label="50-75%" value="50-75" key="50-75" />
          <v-radio label=">75%" value=">75" key=">75" />
        </v-radio-group>
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.etiology') }}</b>
      </p>

      <div class="ml-4">
        <v-radio-group v-model="localValues.vfEtiology" row>
          <v-radio
            :label="$t('Neuroradiology.osteoporotic')"
            value="osteoporotic"
            key="osteoporotic"
          />
          <v-radio
            :label="$t('Neuroradiology.malignant')"
            value="malignant"
            key="malignant"
          />
          <v-radio
            :label="$t('Neuroradiology.neoInventory')"
            value="neoInventory"
            key="neoInventory"
          />
        </v-radio-group>
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.anesthesia') }}</b>
      </p>

      <div class="ml-4">
        <p>
          <b>{{ $t('Neuroradiology.anesthesia') }}</b>
        </p>
        <v-radio-group v-model="localValues.vfAnesthesiaType" row>
          <v-radio
            :label="$t('common.Local')"
            value="sedationSite"
            key="sedationSite"
          />
          <v-radio :label="$t('common.General')" value="geral" key="geral" />
        </v-radio-group>

        <v-radio-group
          v-if="localValues.vfAnesthesiaType === 'geral'"
          v-model="localValues.vfExtubatedOrIntubated"
          row
        >
          <v-radio
            :label="$t('Neuroradiology.extubated')"
            value="extubated"
            key="extubated"
          />
          <v-radio
            :label="$t('Neuroradiology.intubated')"
            value="intubated"
            key="intubated"
          />
        </v-radio-group>

        <p v-if="localValues.vfExtubatedOrIntubated === 'intubated'">
          <b>{{
            $t('Neuroradiology.ventilation') +
              $t('Neuroradiology.spontaneous') +
              '/' +
              $t('Neuroradiology.assisted')
          }}</b>
        </p>
        <v-radio-group
          v-if="localValues.vfExtubatedOrIntubated === 'intubated'"
          v-model="localValues.vfSpontaneousOrAssisted"
          row
        >
          <v-radio
            :label="$t('Neuroradiology.spontaneous')"
            value="spontaneous"
            key="spontaneous"
          />
          <v-radio
            :label="$t('Neuroradiology.assisted')"
            value="assisted"
            key="assisted"
          />
        </v-radio-group>
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.approach') }}</b>
      </p>

      <div class="ml-4">
        <v-radio-group v-model="localValues.vfPedicular" row>
          <v-radio
            :label="$t('Neuroradiology.unipedicular') + $t('common.right')"
            value="rightLeg"
            key="righLeg"
          />
          <v-radio
            :label="$t('Neuroradiology.unipedicular') + $t('common.left')"
            value="leftLeg"
            key="leftLeg"
          />
          <v-radio
            :label="$t('Neuroradiology.bipedicular')"
            value="bipedicular"
            key="bipedicular"
          />
        </v-radio-group>
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.amountOfCement') }}</b>
      </p>

      <div class="ml-4">
        <v-text-field
          v-model="localValues.vfAmountOfCement"
          type="number"
          :label="$t('Neuroradiology.amountOfCement') + '(ml)'"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('common.occurrences') }}</b>
      </p>

      <div class="ml-4">
        <v-radio-group v-model="localValues.vfSpontaneousOrAssisted" row>
          <v-radio
            :label="$t('Neuroradiology.overflowToDisk')"
            value="overflowToDisk"
            key="overflowToDisk"
          />
          <v-radio
            :label="$t('Neuroradiology.overflowToLateroVertebralVeins')"
            value="overflowToLateroVertebralVeins"
            key="overflowToLateroVertebralVeins"
          />
          <v-radio label="Nenhuma" value="none" key="none" />
        </v-radio-group>
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('LogBook.Complications') }}</b>
      </p>

      <div class="ml-4">
        <v-radio-group v-model="localValues.vfComplications" row>
          <v-radio
            v-for="option in yesNoOptions"
            :label="option.text"
            :value="option.value"
            :key="option.value"
          />
        </v-radio-group>

        <v-text-field
          v-if="localValues.vfComplications === 'yes'"
          v-model="localValues.vfComplicationsText"
          type="text"
          :label="$t('LogBook.Complications')"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.painScales') }}</b>
      </p>

      <div class="ml-4">
        <v-select
          v-model="localValues.vfBefore"
          :label="$t('common.before')"
          :items="scaleUnti10"
        />
        <v-select
          v-model="localValues.vfAterProcedure"
          :label="$t('common.afterProcedure')"
          :items="scaleUnti10"
        />
        <v-select
          v-model="localValues.vfHoursAfter"
          label="6 meses"
          :items="scaleUnti10"
        />
      </div>
    </div>

    <div v-if="radicularPainIsSelected">
      <p ref="title">
        <b>{{ $t('Neuroradiology.facetRootPain') }}</b>
      </p>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.characterization') }}</b>
      </p>

      <div class="ml-4">
        <b>{{ $t('common.Local') }}</b>
        <v-radio-group v-model="localValues.rpLocal" row>
          <v-radio :label="$t('Neuroradiology.root')" value="root" key="root" />
          <v-radio
            :label="$t('Neuroradiology.facet')"
            value="facet"
            key="facet"
          />
        </v-radio-group>

        <v-select
          v-if="localValues.rpLocal === 'root'"
          v-model="localValues.rpRoot"
          :label="$t('Neuroradiology.root')"
          :items="rootOptions"
        />

        <v-select
          v-if="localValues.rpLocal === 'facet'"
          v-model="localValues.rpFacet"
          :label="$t('Neuroradiology.facet')"
          :items="facetOptions"
        />

        <v-radio-group v-model="localValues.rpLocalSide" row>
          <v-radio
            v-for="option in directionOptions"
            :label="option.text"
            :value="option.value"
            :key="option.value"
          />
        </v-radio-group>
      </div>

      <div class="ml-4">
        <v-select
          :multiple="true"
          v-model="localValues.rpAssociatedPathology"
          :label="$t('Neuroradiology.associatedPathology')"
          :items="[
            { text: 'Hérnia discal', value: 'herniatedDisc' },
            { text: 'Artropatia facetária', value: 'facetArthropathy' },
            { text: 'Espondilolistese', value: 'spondylolisthesis' },
            { text: 'Pós-cirúrgico', value: 'post-surgical' }
          ]"
        />
      </div>

      <div class="ml-4">
        <p>
          <b>{{ $t('Neuroradiology.anesthesia') }}</b>
        </p>
        <v-radio-group v-model="localValues.rpAnesthesiaLocal" row>
          <v-radio :label="$t('common.Local')" value="local" key="local" />
          <v-radio :label="$t('common.General')" value="geral" key="geral" />
        </v-radio-group>

        <v-radio-group
          v-if="localValues.rpAnesthesiaLocal === 'geral'"
          v-model="localValues.rpExtubatedOrIntubated"
          row
        >
          <v-radio
            :label="$t('Neuroradiology.extubated')"
            value="extubated"
            key="extubated"
          />
          <v-radio
            :label="$t('Neuroradiology.intubated')"
            value="intubated"
            key="intubated"
          />
        </v-radio-group>

        <p v-if="localValues.rpExtubatedOrIntubated === 'intubated'">
          <b>{{
            $t('Neuroradiology.ventilation') +
              $t('Neuroradiology.spontaneous') +
              '/' +
              $t('Neuroradiology.assisted')
          }}</b>
        </p>
        <v-radio-group
          v-if="localValues.rpExtubatedOrIntubated === 'intubated'"
          v-model="localValues.rpSpontaneousOrAssisted"
          row
        >
          <v-radio
            :label="$t('Neuroradiology.spontaneous')"
            value="spontaneous"
            key="spontaneous"
          />
          <v-radio
            :label="$t('Neuroradiology.assisted')"
            value="assisted"
            key="assisted"
          />
        </v-radio-group>
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('common.therapy') }}</b>
      </p>

      <div class="ml-4">
        <b>Infiltração facetária</b>
        <div class="ml-2">
          <v-text-field
            v-model="localValues.rpFacetInfiltrationLidocaine"
            type="number"
            label="Lidocaina (ml)"
          />

          <v-text-field
            v-model="localValues.rpFacetInfiltrationBupivacaine"
            type="number"
            label="Bupivacaína (ml)"
          />

          <v-text-field
            v-model="localValues.rpFacetInfiltrationMethylprednisolone"
            type="number"
            label="Metilprednisolona (mg)"
          />

          <v-text-field
            v-model="localValues.rpFacetInfiltrationOther"
            type="text"
            label="Outro"
          />
        </div>

        <b>Bloqueio ganglionar</b>
        <div class="ml-2">
          <v-text-field
            v-model="localValues.rpGanglionicBlockLidocaine"
            type="number"
            label="Lidocaina (ml)"
          />

          <v-text-field
            v-model="localValues.rpGanglionicBlockBupivacaine"
            type="number"
            label="Bupivacaína (ml)"
          />

          <v-text-field
            v-model="localValues.rpGanglionicBlockMethylprednisolone"
            type="number"
            label="Metilprednisolona (mg)"
          />

          <v-text-field
            v-model="localValues.rpGanglionicBlockFacetInfiltrationOther"
            type="text"
            label="Outro"
          />
        </div>

        <b>Nucleólise</b>
        <div class="ml-2">
          <v-text-field
            v-model="localValues.rpNucleolysisDiskogel"
            type="number"
            label="Diskogel® (ml)"
          />

          <v-text-field
            v-model="localValues.rpNucleolysisOzone"
            type="number"
            label="Ozono (ml)"
          />

          <v-text-field
            v-model="localValues.rpNucleolysisOther"
            type="text"
            label="Outro"
          />
        </div>
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('LogBook.Complications') }}</b>
      </p>

      <div class="ml-4">
        <v-radio-group v-model="localValues.rpComplications" row>
          <v-radio
            v-for="option in yesNoOptions"
            :label="option.text"
            :value="option.value"
            :key="option.value"
          />
        </v-radio-group>

        <v-text-field
          v-if="localValues.rpComplications === 'yes'"
          v-model="localValues.rpComplicationsText"
          type="text"
          :label="$t('LogBook.Complications')"
        />
      </div>

      <p class="ml-2" ref="title">
        <b>{{ $t('Neuroradiology.painScales') }}</b>
      </p>

      <div class="ml-4">
        <v-select
          v-model="localValues.rpBefore"
          :label="$t('common.before')"
          :items="scaleUnti10"
        />
        <v-select
          v-model="localValues.vfAterProcedure"
          :label="$t('common.afterProcedure')"
          :items="scaleUnti10"
        />
        <v-select
          v-model="localValues.rpHoursAfter"
          label="6 meses"
          :items="scaleUnti10"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerPopUp from '@/components/inputs/DatePickerPopUp'
import TimePicker from '@/components/inputs/TimePicker'

export default {
  data() {
    return {
      localValues: {
        hsaVasospasmList: [{}],
        angiographyList: [{}],
        ...this.logEntry
      },
      otherTypes: [
        { text: this.$t('Neuroradiology.fav'), value: 'fav' },
        { text: this.$t('Neuroradiology.mav'), value: 'mav' },
        { text: this.$t('Neuroradiology.traumatic'), value: 'traumatic' },
        {
          text: this.$t('Neuroradiology.intracranialDissection'),
          value: 'intracranial-dissection'
        },
        { text: this.$t('Neuroradiology.perimesencephalicSAH'), value: 'hsa' },
        { text: this.$t('common.other'), value: 'other' }
      ],
      locals: [
        { text: 'CoA', value: 'coa' },
        { text: 'ACA', value: 'aca' },
        { text: 'Bif ACI', value: 'bif-aci' },
        { text: 'Bif ACM', value: 'bif-acm' },
        { text: 'Lenticulo-estriadas', value: 'Lenticule-striated' },
        { text: 'Paraoftálmico', value: 'paraophthalmic' },
        { text: 'CoP', value: 'cop' },
        { text: 'Topo basilar', value: 'basilar-top' },
        { text: 'ACP distal', value: 'distal-acp' },
        { text: 'ASCA/basilar', value: 'asca-basilar' },
        { text: 'PICA', value: 'pica' },
        { text: 'Artéria vertebral (V4)', value: 'vertebral-artery-v4' },
        { text: this.$t('common.other'), value: 'others' }
      ],
      sides: [
        { text: this.$t('common.right'), value: 'right' },
        { text: this.$t('common.left'), value: 'left' },
        { text: this.$t('common.median'), value: 'median' }
      ],
      yesNoOptions: [
        { text: this.$t('common.Yes'), value: 'yes' },
        { text: this.$t('common.No'), value: 'no' }
      ],
      proximalTICIOptions: [
        { text: '0', value: '0' },
        { text: '1', value: '1' },
        { text: '2A', value: '2A' },
        { text: '2A', value: '2A' },
        { text: '2B', value: '2B' },
        { text: '2C', value: '2C' },
        { text: '3', value: '3' }
      ],
      radiologicFindingTypes: [
        { text: this.$t('Neuroradiology.aneurysm'), value: 'aneurysm' },
        { text: this.$t('Neuroradiology.mav'), value: 'mav' },
        { text: this.$t('Neuroradiology.fav'), value: 'fav' },
        {
          text: this.$t('Neuroradiology.carotidStenosis'),
          value: 'carotidStenosis'
        },
        {
          text: this.$t('Neuroradiology.intracranialStenosis'),
          value: 'intracranialStenosis'
        },
        { text: this.$t('common.other'), value: 'others' }
      ],
      scaleUnti10: Array(10)
        .fill()
        .map((v, index) => index + 1),
      scaleUntil5: Array(5)
        .fill()
        .map((v, index) => index + 1),
      scaleFrom0To5: Array(6)
        .fill()
        .map((v, index) => index),
      scaleUntil4: Array(4)
        .fill()
        .map((v, index) => index + 1),
      scaleFrom3To15: Array(13)
        .fill()
        .map((v, index) => index + 3),
      scaleUntil3: Array(3)
        .fill()
        .map((v, index) => index + 1),
      directionOptions: [
        { text: this.$t('common.right'), value: 'right' },
        { text: this.$t('common.left'), value: 'left' }
      ],
      ihIntracranialHemorrhageOptions: [
        { text: this.$t('Neuroradiology.aneurysm'), value: 'aneurysm' },
        { text: this.$t('Neuroradiology.mav'), value: 'mav' },
        { text: this.$t('Neuroradiology.fav'), value: 'fav' },
        {
          text: this.$t('Neuroradiology.intracranialDissection'),
          value: 'intracranial-dissection'
        },
        { text: this.$t('common.other'), value: 'other' }
      ],
      rootOptions: [
        { text: 'C1', value: 'C1' },
        { text: 'C2', value: 'C2' },
        { text: 'C3', value: 'C3' },
        { text: 'C4', value: 'C4' },
        { text: 'C5', value: 'C5' },
        { text: 'C6', value: 'C6' },
        { text: 'C7', value: 'C7' },
        { text: 'C8', value: 'C8' },
        { text: 'T1', value: 'T1' },
        { text: 'T2', value: 'T2' },
        { text: 'T3', value: 'T3' },
        { text: 'T4', value: 'T4' },
        { text: 'T5', value: 'T5' },
        { text: 'T6', value: 'T6' },
        { text: 'T7', value: 'T7' },
        { text: 'T8', value: 'T8' },
        { text: 'T9', value: 'T9' },
        { text: 'T10', value: 'T10' },
        { text: 'T11', value: 'T11' },
        { text: 'T12', value: 'T12' },
        { text: 'L1', value: 'L1' },
        { text: 'L2', value: 'L2' },
        { text: 'L3', value: 'L3' },
        { text: 'L4', value: 'L4' },
        { text: 'L5', value: 'L5' },
        { text: 'S1', value: 'S1' },
        { text: 'S2', value: 'S2' },
        { text: 'S3', value: 'S3' },
        { text: 'S4', value: 'S4' },
        { text: 'Sacro', value: 'Sacro' }
      ],
      facetOptions: [
        { text: 'C1-C2', value: 'C1-C2' },
        { text: 'C2-C3', value: 'C2-C3' },
        { text: 'C3-C4', value: 'C3-C4' },
        { text: 'C4-C5', value: 'C4-C5' },
        { text: 'C5-C6', value: 'C5-C6' },
        { text: 'C6-C7', value: 'C6-C7' },
        { text: 'C7-D1', value: 'C7-D1' },
        { text: 'D1-D2', value: 'D1-D2' },
        { text: 'D2-D3', value: 'D2-D3' },
        { text: 'D3-D4', value: 'D3-D4' },
        { text: 'D4-D5', value: 'D4-D5' },
        { text: 'D5-D6', value: 'D5-D6' },
        { text: 'D6-D7', value: 'D6-D7' },
        { text: 'D7-D8', value: 'D7-D8' },
        { text: 'D8-D9', value: 'D8-D9' },
        { text: 'D9-D10', value: 'D9-D10' },
        { text: 'D10-D11', value: 'D10-D11' },
        { text: 'D11-D12', value: 'D11-D12' },
        { text: 'D12-L1', value: 'D12-L1' },
        { text: 'L1-L2', value: 'L1-L2' },
        { text: 'L2-L3', value: 'L2-L3' },
        { text: 'L3-L4', value: 'L3-L4' },
        { text: 'L4-L5', value: 'L4-L5' },
        { text: 'L5-S1', value: 'L5-S1' }
      ],
      thrombusLocationOptions: [
        { text: 'Direito', value: 'right' },
        { text: 'Esquerdo', value: 'left' },
        { text: 'Mediano', value: 'middle' }
      ],
      rfaLocalOptions: [
        { text: this.$t('Neuroradiology.front'), value: 'front' },
        { text: this.$t('Neuroradiology.temporal'), value: 'temporal' },
        { text: this.$t('Neuroradiology.parietal'), value: 'parietal' },
        { text: this.$t('Neuroradiology.occipital'), value: 'occipital' },
        { text: this.$t('Neuroradiology.deep'), value: 'deep' },
        {
          text: this.$t('Neuroradiology.cerebellarHemisphere'),
          value: 'cerebellarHemisphere'
        },
        {
          text: this.$t('Neuroradiology.cermellumVermis'),
          value: 'cermellumVermis'
        }
      ],
      rfaTypeOptions: [
        { text: 'Cortical/sulcal', value: 'front' },
        {
          text: this.$t('Neuroradiology.subcorticalTenementGiral'),
          value: 'subcorticalTenementGiral'
        },
        {
          text: this.$t('Neuroradiology.corticoVentricular'),
          value: 'corticoVentricular'
        },
        {
          text: this.$t('Neuroradiology.cornishCallous'),
          value: 'cornishCallous'
        },
        { text: this.$t('Neuroradiology.coroid'), value: 'coroid' },
        { text: this.$t('Neuroradiology.plexiform'), value: 'plexiform' },
        { text: this.$t('Neuroradiology.fuzzy'), value: 'fuzzy' },
        {
          text: this.$t('Neuroradiology.unicompartmental'),
          value: 'unicompartmental'
        },
        {
          text: this.$t('Neuroradiology.Multicompartmental'),
          value: 'multicompartmental'
        }
      ],
      rffTypeOptions: [
        {
          text: this.$t('Neuroradiology.transverseSinus'),
          value: 'transverseSinus'
        },
        { text: this.$t('Neuroradiology.sigmoidSinus'), value: 'sigmoidSinus' },
        { text: 'SLS', value: 'sls' },
        {
          text: this.$t('Neuroradiology.straightBreast'),
          value: 'straightBreast'
        },
        { text: this.$t('Neuroradiology.galenaVein'), value: 'galenaVein' },
        { text: this.$t('common.right'), value: 'right' },
        { text: this.$t('common.left'), value: 'left' }
      ],
      rffVenousDrainageOptions: [
        { text: 'Cortical', value: 'cortical' },
        { text: 'Dural anterógrada', value: 'anterogradeDural' },
        { text: 'Dural retrógrada', value: 'duralRetrograde' },
        { text: 'Oclusão seio Lateral', value: 'lateralSinusOcclusion' }
      ],
      rffBordenClassificationOptions: [
        { text: '1', value: '1' },
        { text: '2a', value: '2a' },
        { text: '2b', value: '2b' },
        { text: '3', value: '3' }
      ]
    }
  },
  props: {
    logEntry: {
      type: Object
    },
    component: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    TimePicker,
    DatePickerPopUp
  },
  computed: {
    currentEpisode() {
      return this.localValues[this.component.id]
    },
    hypertensionIsSelected() {
      return this.currentEpisode === 'subarachnoid-hemorrhage'
    },
    intracranialHemorrhageIsSelected() {
      return this.currentEpisode === 'intracranial-hemorrhage'
    },
    acuteIschemicStrokeIsSelected() {
      return this.currentEpisode === 'acute-ischemic-stroke'
    },
    symptomaticCarotidStenosisIsSelected() {
      return this.currentEpisode === 'carotid-stenosis'
    },
    intracranialStenosisIsSelected() {
      return this.currentEpisode === 'intracranial-stenosis'
    },
    radiologicFindingIsSelected() {
      return this.currentEpisode === 'imaging-finding'
    },
    isMav() {
      return this.localValues.radiologicFinding === 'mav'
    },
    isFav() {
      return this.localValues.radiologicFinding === 'fav'
    },
    isRadiologicFindingSymptomaticCarotidStenosisIsSelected() {
      return (
        this.currentEpisode === 'imaging-finding' &&
        this.localValues.radiologicFinding === 'carotidStenosis'
      )
    },
    isRadiologicFindingIntracranialStenosisIsSelected() {
      return (
        this.currentEpisode === 'imaging-finding' &&
        this.localValues.radiologicFinding === 'intracranialStenosis'
      )
    },
    vertebralFractureIsSelected() {
      return this.currentEpisode === 'vertebral-fracture'
    },
    radicularPainIsSelected() {
      return this.currentEpisode === 'radicular-pain'
    },
    isOther() {
      return this.localValues.hsaAneurysm === 'no'
    },
    isGreaterThan1() {
      return this.localValues.hsaAneurysm === '>1'
    },
    isNotOther() {
      return this.localValues.hsaAneurysm === 'yes'
    },
    optionsTypes() {
      let options = []
      switch (this.logEntry['intervention-type']) {
        case 'angiography':
          options = [
            'subarachnoid-hemorrhage',
            'intracranial-hemorrhage',
            'acute-ischemic-stroke',
            'carotid-stenosis',
            'intracranial-stenosis',
            'imaging-finding'
          ]
          break
        case 'raquis-intervention':
          options = ['vertebral-fracture', 'radicular-pain', 'biopsy']
          break
        case 'dacryocystography':
          options = []
          break
      }

      return options.map(o => this.component.options.find(co => co.value === o))
    }
  },
  methods: {},
  watch: {
    localValues: {
      handler() {
        this.$emit('onUpdateData', this.localValues)
      },
      deep: true
    }
  }
}
</script>
